import { useTranslation } from 'react-i18next';
import MaskIcon from '@/components/ui/MaskIcon';

interface Props {
  /** Unités restées sur cet appareil sans être envoyées — voir `readUnsentWaiterQty`. */
  qty: number;
  /** Sert aussi de `data-testid`, et de cible à l'`aria-describedby` de la carte. */
  id: string;
}

/**
 * DF-0383 — des plats saisis et pas envoyés ne laissaient aucune trace hors du
 * ticket : la tuile d'une table dont le panier attend ressemblait à toutes les
 * autres. Le panier et son compte, au coin opposé au ⋮ et à la pastille « à
 * valider », disent où ces plats sont restés. Posée sur la carte sans rien
 * intercepter : l'appui ouvre la table, comme partout ailleurs sur la carte.
 *
 * Elle déborde de 6px dans la gouttière, comme les pastilles de la tuile
 * voisine : le liseré couleur de page et le `z-index` (sous la barre collante,
 * `z-10`) gardent les deux formes distinctes quand elles s'y rencontrent.
 */
export default function UnsentCartBadge({ qty, id }: Props) {
  const { t } = useTranslation();
  const label = t(qty === 1 ? 'waiter.notes.card.unsentOne' : 'waiter.notes.card.unsentOther', { n: qty });
  return (
    <span
      id={id}
      data-testid={id}
      role="img"
      aria-label={label}
      title={label}
      className="pointer-events-none absolute z-[1] -bottom-1.5 -end-1.5 h-[22px] px-1 rounded-full text-white font-sans text-[13px] font-bold flex items-center gap-0.5"
      style={{ backgroundColor: 'var(--w-danger)', boxShadow: '0 0 0 1px var(--cream)' }}
    >
      <MaskIcon src="/img/icon-cart.svg" className="w-3.5 h-3.5" />
      {qty}
    </span>
  );
}
